import LoadingSpinner from "features/shared/components/loaders/LoadingSpinner";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {}

const LoginPage: React.FC<IProps> = (props) => { 
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  return (
    <>
      <LoadingSpinner 
        useContainerBg={false}
        title={tLabels("loginPage.title")}
      />
    </>
  );
};

export default LoginPage;
